var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hide-scrollbar flex overflow-x-auto overflow-y-hidden flex-grow space-x-3 sm:pl-10 sm:space-x-6 lg:pl-16"},[_c('div',{staticClass:"shrink-0 w-1"}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"shrink-0 w-1"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }